/* ============================================================
   Routine Finder Newsletter Module V4
============================================================ */

const NEWSLETTER_BACKGROUND = 'https://cdn.shopify.com/s/files/1/0974/0212/6661/files/6.pem-delian-routine-finder.jpg?v=1763881013';

function pemrf_v5_showNewsletterStep() {
  console.log("=== SHOW NEWSLETTER STEP ===");

  const q = pemrf_v5_qs("#pemrf-questions-v5");
  const r = pemrf_v5_qs("#pemrf-result-v5");
  const n = pemrf_v5_qs("#pemrf-newsletter-step-v5");

  if (q) q.style.display = "none";
  if (r) r.style.display = "none";

  if (n) {
    n.style.display = "flex";
    if (window.innerWidth > 768) {
      n.style.backgroundImage = `url('${NEWSLETTER_BACKGROUND}')`;
    } else {
      n.style.backgroundImage = 'none';
    }
    
    pemrf_v5_applyNewsletterTranslations();
  }

  window.scrollTo({ top: 0, behavior: 'smooth' });

  pemrf_v5_createHiddenIframe();
}

/* Create hidden iframe */
function pemrf_v5_createHiddenIframe() {
  let iframe = document.getElementById("pemrf-submit-iframe-v5");
  if (iframe) return iframe;

  iframe = document.createElement("iframe");
  iframe.id = "pemrf-submit-iframe-v5";
  iframe.name = "pemrf-submit-iframe-v5";
  iframe.style.display = "none";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "none";

  document.body.appendChild(iframe);
  console.log("Hidden iframe created");
  return iframe;
}

/* Apply translations */
function pemrf_v5_applyNewsletterTranslations() {
  try {
    const lang = pemrf_v5_getLangPack();
    
    // Get locale from URL path instead of data attribute
    const pathParts = window.location.pathname.split('/').filter(p => p);
    const localeFromUrl = pathParts[0] || 'hu-hu'; // First part of path: "de-at", "en-cz", etc.
    const prefix = `/${localeFromUrl}`;
    
    document.querySelectorAll('[data-lang]').forEach(el => {
      const key = el.getAttribute('data-lang');
      const keys = key.split('.');
      let value = lang;
      keys.forEach(k => value = value?.[k]);
      if (value) {
        if (el.tagName === 'INPUT') el.placeholder = value;
        else el.textContent = value;
      }
    });
    
    // Generate GDPR HTML dynamically with correct locale prefix
    const gdprEl = document.getElementById('pemrf-gdpr-text');
    if (gdprEl && lang.newsletter.gdpr_html) {
      let gdprHtml = lang.newsletter.gdpr_html;
      // Replace /pages/ with /{locale}/pages/
      gdprHtml = gdprHtml.replace(/href="\/pages\//g, `href="${prefix}/pages/`);
      gdprEl.innerHTML = gdprHtml;
    }
    
  } catch (error) {
    console.error("Error applying translations:", error);
  }
}

/* FORM SUBMIT HANDLER */
document.addEventListener(
  "submit",
  function (e) {
    const form = e.target;
    if (!form) return;
    if (form.id !== "ContactSubscribe-rf-v5") return;

    const lang = pemrf_v5_getLangPack();
    const emailInput = form.querySelector('input[type="email"]');
    const gdprCheckbox = form.querySelector('#gdpr-checkbox-v5');
    const submitBtn = form.querySelector('button[type="submit"]');
    const tagInput = form.querySelector('#pemrf-tags-v5');

    const email = emailInput?.value?.trim() || "";

    /* email required */
    if (!email) {
      e.preventDefault();
      e.stopImmediatePropagation();
      alert(lang.newsletter.errors.email_required);
      return;
    }

    /* email validation */
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      alert(lang.newsletter.errors.email_invalid);
      return;
    }

    /* GDPR required 
    if (!gdprCheckbox?.checked) {
      e.preventDefault();
      e.stopImmediatePropagation();
      alert(lang.newsletter.errors.gdpr_required);
      return;
    }
*/
    /* avoid double submit */
    if (form.dataset.pemrfProcessed === "true") {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    form.dataset.pemrfProcessed = "true";

    const originalBtnContent = submitBtn?.innerHTML || "";
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = lang.newsletter.processing;
    }

    /* ------------ TIMESTAMP (YYMMDD) ------------ */
    const date = new Date();
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yy = String(date.getFullYear()).slice(-2);

  const hh = String(date.getHours()).padStart(2, "0");
  const min = String(date.getMinutes()).padStart(2, "0");
  const sec = String(date.getSeconds()).padStart(2, "0");

const stamp = `${yy}${mm}${dd}-${hh}${min}${sec}`;


    /* ------------ BUILD TAGS ------------ */
    const a = window.PEMRF_V5.answers;
    const handled = pemrf_v5_collectHandles();

    const concernTags = (a.concerns || []).map(c => `rfq_${stamp}_concern:${c}`);
    const recommendedTags = handled.map(h => `rfq_${stamp}_rec:${h}`);

    // Add the selected Iconic Lips variant to recommended tags
    const iconicLips = window.PEMRF_V5.selectedIconicLips;
    if (iconicLips) {
      recommendedTags.push(`rfq_${stamp}_rec:${iconicLips.handle}`);
    }

    const formDefaultTags = (tagInput?.value || "")
      .split(",")
      .map(t => t.trim())
      .filter(t => t.length > 0);

    const newRfTags = [`routine_finder_quiz_${stamp}`];
    newRfTags.push("rfq_completed");

    if (a.age) newRfTags.push(`rfq_${stamp}_age:${a.age}`);
    if (a.skin_type) newRfTags.push(`rfq_${stamp}_skin:${a.skin_type}`);
    if (a.eye_area) newRfTags.push(`rfq_${stamp}_eye:${a.eye_area}`);
    if (a.cleanser) newRfTags.push(`rfq_${stamp}_cleanser:${a.cleanser}`);

    const allTags = [
      ...new Set([
        ...formDefaultTags,
        ...newRfTags,
        ...concernTags,
        ...recommendedTags
      ])
    ];

    console.log("Final timestamped tags:", allTags);

    if (tagInput) {
      tagInput.value = allTags.join(", ");
    }

    /* iframe callback */
    const iframe = pemrf_v5_createHiddenIframe();
    if (iframe) {
      iframe.onload = () => {
        console.log("Newsletter iframe loaded – Shopify processed the form.");

        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = originalBtnContent;
        }

        form.dataset.pemrfProcessed = "false";

        pemrf_v5_closeNewsletterAndShowResult();
      };
    }

    /* native POST → iframe */
    form.target = "pemrf-submit-iframe-v5";
  },
  true
);

/* Close newsletter → show result */
function pemrf_v5_closeNewsletterAndShowResult() {
  const n = pemrf_v5_qs("#pemrf-newsletter-step-v5");
  if (n) n.style.display = "none";

  const lang = pemrf_v5_getLangPack();
  const scores = window.PEMRF_V5.__scores || {};
  const hasScores = Object.keys(scores).some(key => scores[key] > 0);

  // IF WE HAVE SCORES → SHOW RESULT PAGE
  if (hasScores) {
    pemrf_v5_renderResult(scores);
    return;
  }

  // ELSE (NO SCORES) → SHOW EMPTY RESULT + BUTTON
  const result = pemrf_v5_qs("#pemrf-result-v5");
  if (result) {
    result.style.display = "block";
    result.innerHTML = `
      <div style="text-align:center; padding:80px 20px;">
        <h2 style="margin-bottom:24px; font-size:22px;">
          ${lang.newsletter.no_routine}
        </h2>

        <button id="pemrf-restart-quiz"
          style="
            background:#000;
            color:#fff;
            padding:14px 26px;
            border:none;
            cursor:pointer;
            font-size:16px;
            text-transform:uppercase;
          ">
          ${lang.newsletter.restart_quiz}
        </button>
      </div>
    `;

    document.getElementById("pemrf-restart-quiz").onclick = () => {
      window.PEMRF_V5.currentStep = 0;
      pemrf_v5_renderQuestions();
    };
  }
}


/* Skip newsletter → show result*/
document.addEventListener("click", function (e) {
  if (e.target.classList.contains("pemrf-skip-newsletter-btn-v5")) {
    const scores = window.PEMRF_V5.__scores || {};
    pemrf_v5_renderResult(scores);
  }
});